const availableFilters = [
	// { label: 'Type', key: 'Contact_Classification_1__c', type: 'text'},
	// { label: 'Cloud', key: 'Account_Name__c', type: 'list', values: ["AWS", "MS"]},
	// { label: 'Priority', key: 'Priority__c', type: 'list', values: ["Low", "Medium", "High"]},
	{ label: 'Type', key: 'campaign_type_name', type: 'list', values: ["Email", "LinkedIn", "Mixed Media", "Advertisment", "Seminar/ Conference", "Banner Ads", "Public Relations", "Other" ]},
	// { label: 'Opportunity Heat', key: 'Opportunity_Heat__c', type: 'list', values: ["Standard", "Hot"]},
	{ label: 'Status', key: 'campaign_status_name', type: 'list', values: ["Planned", "In Progress", "Completed", "Aborted"]},
	// { label: 'Role Category', key: 'Role_Category__c', type: 'text'}
];

export default availableFilters;
